import CableReady from 'cable_ready'
import consumer from "./consumer"

consumer.subscriptions.create("TestChannel", {
  connected() {
    this.send({message: 'Client is live'})
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    // Called when there's incoming data on the websocket for this channel
    console.log(data)
  }
});
